import { Tab, Tabs, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, MenuItem, IconButton, CircularProgress } from '@material-ui/core'
import { useEffect, useState } from 'react'
import styled from 'styled-components'
import AdminPanelTemplate from '../templates/AdminPanelTemplate'
import TestimonialTable from './TestimonialTable'
import { DB } from '../../firebase'
import AddIcon from '@material-ui/icons/Add'
import CloseIcon from '@material-ui/icons/Close'
import StarIcon from '@material-ui/icons/Star'
import StarBorderIcon from '@material-ui/icons/StarBorder'
import StarHalfIcon from '@material-ui/icons/StarHalf'
import CloudUploadIcon from '@material-ui/icons/CloudUpload'

// IMPORTANT: Change this to your actual upload endpoint
const UPLOAD_ENDPOINT = process.env.REACT_APP_IMAGE_UPLOAD_API
// Or for testing on localhost: 'http://localhost/api/upload-testimonial.php'

function Testimonials() {
    const [tabNo, setTabNo] = useState(0)
    const [activeTestimonials, setActiveTestimonials] = useState([])
    const [inactiveTestimonials, setInactiveTestimonials] = useState([])
    const [openDialog, setOpenDialog] = useState(false)
    const [editMode, setEditMode] = useState(false)
    const [currentTestimonialId, setCurrentTestimonialId] = useState(null)
    const [saving, setSaving] = useState(false)
    const [uploading, setUploading] = useState(false)

    // Form state
    const [formData, setFormData] = useState({
        image: '',
        imageFile: null,
        testimonial: '',
        rating: 5,
        name: '',
        designation: '',
        studentClass: '',
        subject: '',
        active: true,
        timestamp: null
    })

    const handleTabChange = (event, newtabNo) => {
        setTabNo(newtabNo)
    }

    // Get active testimonials
    function getActiveTestimonials() {
        console.log('Getting Active Testimonials')
        DB.collection('testimonials')
            .where('active', '==', true)
            .orderBy('timestamp', 'desc')
            .onSnapshot((querySnapshot) => {
                var testimonials = []
                querySnapshot.forEach((doc) => {
                    testimonials.push({
                        id: doc.id,
                        ...doc.data()
                    })
                })
                setActiveTestimonials(testimonials)
            })
    }

    // Get inactive testimonials
    function getInactiveTestimonials() {
        console.log('Getting Inactive Testimonials')
        DB.collection('testimonials')
            .where('active', '==', false)
            .orderBy('timestamp', 'desc')
            .onSnapshot((querySnapshot) => {
                var testimonials = []
                querySnapshot.forEach((doc) => {
                    testimonials.push({
                        id: doc.id,
                        ...doc.data()
                    })
                })
                setInactiveTestimonials(testimonials)
            })
    }

    useEffect(() => {
        tabNo === 0 && !activeTestimonials.length && getActiveTestimonials()
        tabNo === 1 && !inactiveTestimonials.length && getInactiveTestimonials()
        // eslint-disable-next-line 
    }, [tabNo])

    // Handle form input changes
    const handleInputChange = (e) => {
        const { name, value } = e.target
        setFormData({
            ...formData,
            [name]: value
        })
    }

    // Handle image file selection
    const handleImageChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0]
            
            // Validate file size (5MB)
            if (file.size > 5 * 1024 * 1024) {
                alert('File size must be less than 5MB')
                return
            }

            // Validate file type
            const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/gif']
            if (!validTypes.includes(file.type)) {
                alert('Only JPG, PNG, WEBP, and GIF images are allowed')
                return
            }

            setFormData({
                ...formData,
                imageFile: file,
                image: URL.createObjectURL(file) // Preview
            })
        }
    }

    // Upload image to PHP server
    const uploadImageToServer = async () => {
        if (!formData.imageFile) {
            return formData.image // Return existing URL if no new file
        }

        setUploading(true)

        try {
            const formDataToSend = new FormData()
            formDataToSend.append('image', formData.imageFile)
            console.log(UPLOAD_ENDPOINT)
            const response = await fetch(UPLOAD_ENDPOINT, {
                method: 'POST',
                body: formDataToSend
            })

            const result = await response.json()

            if (result.success) {
                setUploading(false)
                return result.data.url
            } else {
                throw new Error(result.message || 'Upload failed')
            }
        } catch (error) {
            console.error('Upload error:', error)
            setUploading(false)
            alert(`Error uploading image: ${error.message}`)
            return null
        }
    }

    // Handle star rating click
    const handleRatingClick = (rating) => {
        setFormData({
            ...formData,
            rating: rating
        })
    }

    // Render star rating selector
    const renderStarSelector = () => {
        const stars = []
        for (let i = 0.5; i <= 5; i += 0.5) {
            const isHalf = i % 1 !== 0
            const isSelected = formData.rating >= i
            const isHalfSelected = formData.rating === i - 0.5 && isHalf

            stars.push(
                <IconButton
                    key={i}
                    onClick={() => handleRatingClick(i)}
                    style={{ padding: '4px' }}
                >
                    {isSelected ? (
                        <StarIcon style={{ color: '#f39c12', fontSize: '2rem' }} />
                    ) : isHalfSelected || (isHalf && formData.rating > i - 0.5 && formData.rating < i) ? (
                        <StarHalfIcon style={{ color: '#f39c12', fontSize: '2rem' }} />
                    ) : (
                        <StarBorderIcon style={{ color: '#ddd', fontSize: '2rem' }} />
                    )}
                </IconButton>
            )
        }
        return stars
    }

    // Open dialog for add/edit
    const handleOpenDialog = (testimonial = null) => {
        if (testimonial) {
            setEditMode(true)
            setCurrentTestimonialId(testimonial.id)
            setFormData({
                image: testimonial.image || '',
                imageFile: null,
                testimonial: testimonial.testimonial || '',
                rating: testimonial.rating || 5,
                name: testimonial.name || '',
                designation: testimonial.designation || '',
                studentClass: testimonial.studentClass || '',
                subject: testimonial.subject || '',
                active: testimonial.active !== undefined ? testimonial.active : true,
                timestamp: testimonial.timestamp
            })
        } else {
            setEditMode(false)
            setCurrentTestimonialId(null)
            setFormData({
                image: '',
                imageFile: null,
                testimonial: '',
                rating: 5,
                name: '',
                designation: '',
                studentClass: '',
                subject: '',
                active: true,
                timestamp: null
            })
        }
        setOpenDialog(true)
    }

    // Close dialog
    const handleCloseDialog = () => {
        setOpenDialog(false)
        setEditMode(false)
        setCurrentTestimonialId(null)
        setFormData({
            image: '',
            imageFile: null,
            testimonial: '',
            rating: 5,
            name: '',
            designation: '',
            studentClass: '',
            subject: '',
            active: true,
            timestamp: null
        })
    }

    // Save testimonial
    const handleSaveTestimonial = async () => {
        // Validation
        if (!formData.name.trim()) {
            alert('Please enter a name')
            return
        }
        if (!formData.testimonial.trim()) {
            alert('Please enter a testimonial')
            return
        }
        if (!formData.designation.trim()) {
            alert('Please select a role')
            return
        }
        if (!formData.image && !formData.imageFile) {
            alert('Please select an image')
            return
        }

        setSaving(true)

        try {
            // Upload image to server
            const imageUrl = await uploadImageToServer()
            
            if (!imageUrl) {
                setSaving(false)
                return
            }

            const testimonialData = {
                image: imageUrl,
                testimonial: formData.testimonial,
                rating: formData.rating,
                name: formData.name,
                designation: formData.designation,
                studentClass: formData.studentClass,
                subject: formData.subject,
                active: formData.active,
                timestamp: formData.timestamp || new Date()
            }

            if (editMode) {
                // Update existing testimonial
                await DB.collection('testimonials').doc(currentTestimonialId).update(testimonialData)
                alert('Testimonial updated successfully!')
            } else {
                // Add new testimonial
                await DB.collection('testimonials').add(testimonialData)
                alert('Testimonial added successfully!')
            }

            handleCloseDialog()
            setSaving(false)
        } catch (error) {
            console.error('Error saving testimonial:', error)
            alert('Error saving testimonial. Please try again.')
            setSaving(false)
        }
    }

    return (
        <AdminPanelTemplate>
            <HeaderContainer>
                <Heading>Testimonials Management</Heading>
                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddIcon />}
                    onClick={() => handleOpenDialog()}
                    style={{ 
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        color: 'white',
                        fontWeight: 600,
                        padding: '10px 25px',
                        borderRadius: '8px'
                    }}
                >
                    Add Testimonial
                </Button>
            </HeaderContainer>

            <TabContainer>
                <Tabs
                    value={tabNo}
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={handleTabChange}
                    aria-label="testimonials-tabs"
                >
                    {[
                        ['Active Testimonials', activeTestimonials],
                        ['Inactive Testimonials', inactiveTestimonials]
                    ].map((item, key) => (
                        <Tab
                            key={key}
                            label={`${item[0]} ${
                                tabNo === key ? `(${item[1].length})` : ''
                            }`}
                        />
                    ))}
                </Tabs>
            </TabContainer>

            <div>
                {[
                    [activeTestimonials, ['edit', 'deactivate']],
                    [inactiveTestimonials, ['edit', 'activate', 'delete']]
                ].map(
                    (item, key) =>
                        tabNo === key && (
                            <div key={key}>
                                {(!!item[0].length && (
                                    <TestimonialTable
                                        testimonialData={item[0]}
                                        tools={item[1]}
                                        onEdit={handleOpenDialog}
                                    />
                                )) || <NoDataFound>No Testimonials Found</NoDataFound>}
                            </div>
                        )
                )}
            </div>

            {/* Add/Edit Dialog */}
            <Dialog 
                open={openDialog} 
                onClose={handleCloseDialog}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle>
                    <DialogTitleContainer>
                        <span>{editMode ? 'Edit Testimonial' : 'Add New Testimonial'}</span>
                        <IconButton onClick={handleCloseDialog}>
                            <CloseIcon />
                        </IconButton>
                    </DialogTitleContainer>
                </DialogTitle>
                <DialogContent dividers>
                    <FormContainer>
                        {/* Image Upload */}
                        <FormSection>
                            <Label>Testimonial Image *</Label>
                            <ImageUploadContainer>
                                <input
                                    accept="image/jpeg,image/jpg,image/png,image/webp,image/gif"
                                    style={{ display: 'none' }}
                                    id="testimonial-image-upload"
                                    type="file"
                                    onChange={handleImageChange}
                                />
                                <label htmlFor="testimonial-image-upload">
                                    <Button 
                                        variant="outlined" 
                                        component="span"
                                        startIcon={<CloudUploadIcon />}
                                        style={{ marginBottom: '10px' }}
                                    >
                                        Choose Image
                                    </Button>
                                </label>
                                {formData.image && (
                                    <ImagePreview>
                                        <img src={formData.image} alt="Preview" />
                                        {uploading && (
                                            <UploadOverlay>
                                                <CircularProgress />
                                                <p>Uploading...</p>
                                            </UploadOverlay>
                                        )}
                                    </ImagePreview>
                                )}
                            </ImageUploadContainer>
                            <HelperText>
                                Max 5MB. Formats: JPG, PNG, WEBP, GIF. Recommended: 500x500px
                            </HelperText>
                        </FormSection>

                        {/* Testimonial Text */}
                        <FormSection>
                            <TextField
                                fullWidth
                                multiline
                                rows={4}
                                label="Testimonial *"
                                name="testimonial"
                                value={formData.testimonial}
                                onChange={handleInputChange}
                                variant="outlined"
                                placeholder="Enter the testimonial text here..."
                            />
                        </FormSection>

                        {/* Star Rating */}
                        <FormSection>
                            <Label>Rating * (Click to select, supports half stars)</Label>
                            <StarContainer>
                                {renderStarSelector()}
                                <RatingText>{formData.rating} / 5</RatingText>
                            </StarContainer>
                        </FormSection>

                        {/* Name */}
                        <FormSection>
                            <TextField
                                fullWidth
                                label="Name *"
                                name="name"
                                value={formData.name}
                                onChange={handleInputChange}
                                variant="outlined"
                                placeholder="e.g., Shilpa Bala"
                            />
                        </FormSection>

                        {/* Role */}
                        <FormSection>
                            <TextField
                                fullWidth
                                select
                                label="Role *"
                                name="designation"
                                value={formData.designation}
                                onChange={handleInputChange}
                                variant="outlined"
                            >
                                <MenuItem value="Student">Student</MenuItem>
                                <MenuItem value="Parent">Parent</MenuItem>
                            </TextField>
                        </FormSection>

                        {/* Class */}
                        <FormSection>
                            <TextField
                                fullWidth
                                label="Class (Optional)"
                                name="studentClass"
                                value={formData.studentClass}
                                onChange={handleInputChange}
                                variant="outlined"
                                placeholder="e.g., 10"
                                helperText="Only applicable for students"
                            />
                        </FormSection>

                        {/* Subject */}
                        <FormSection>
                            <TextField
                                fullWidth
                                label="Subject (Optional)"
                                name="subject"
                                value={formData.subject}
                                onChange={handleInputChange}
                                variant="outlined"
                                placeholder="e.g., Math, Science, English"
                            />
                        </FormSection>

                        {/* Active Status */}
                        <FormSection>
                            <TextField
                                fullWidth
                                select
                                label="Status"
                                name="active"
                                value={formData.active}
                                onChange={(e) => setFormData({ ...formData, active: e.target.value === 'true' })}
                                variant="outlined"
                            >
                                <MenuItem value={true}>Active (Show on website)</MenuItem>
                                <MenuItem value={false}>Inactive (Hidden)</MenuItem>
                            </TextField>
                        </FormSection>
                    </FormContainer>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} color="default" disabled={saving || uploading}>
                        Cancel
                    </Button>
                    <Button 
                        onClick={handleSaveTestimonial} 
                        color="primary" 
                        variant="contained"
                        disabled={saving || uploading}
                        style={{
                            background: (saving || uploading) ? '#ccc' : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            color: 'white'
                        }}
                    >
                        {uploading ? 'Uploading Image...' : (saving ? 'Saving...' : (editMode ? 'Update' : 'Add'))} Testimonial
                    </Button>
                </DialogActions>
            </Dialog>
        </AdminPanelTemplate>
    )
}

const HeaderContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 1rem;
    margin-bottom: 1rem;
    flex-wrap: wrap;
    gap: 1rem;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
    }
`

const Heading = styled.h1`
    color: #333;
    font-weight: 700;
    font-size: 1.6rem;
`

const TabContainer = styled.div`
    background-color: #fff;
    border: 1px solid #dddddd;
    box-shadow: 0px 8px 12px rgba(0, 0, 0, 0.07);
    border-radius: 15px;
    padding: 15px;
    margin: 30px auto;
    padding-bottom: 0;
    width: 100%;

    .MuiTabs-flexContainer {
        justify-content: space-between;
    }
`

const NoDataFound = styled.p`
    color: #333;
    text-align: center;
    margin-top: 50px;
    font-weight: 500;
`

const DialogTitleContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`

const FormContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 10px 0;
`

const FormSection = styled.div`
    display: flex;
    flex-direction: column;
`

const Label = styled.label`
    font-weight: 600;
    color: #333;
    margin-bottom: 8px;
    font-size: 0.95rem;
`

const ImageUploadContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
`

const ImagePreview = styled.div`
    margin-top: 10px;
    width: 200px;
    height: 200px;
    border-radius: 10px;
    overflow: hidden;
    border: 2px solid #ddd;
    position: relative;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`

const UploadOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: white;

    p {
        margin-top: 10px;
        font-weight: 600;
    }
`

const HelperText = styled.span`
    font-size: 0.8rem;
    color: #888;
    margin-top: 5px;
`

const StarContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
`

const RatingText = styled.span`
    font-weight: 600;
    color: #333;
    margin-left: 10px;
    font-size: 1.1rem;
`

export default Testimonials